import confetti from "canvas-confetti"
import { vibratePattern } from "../utils/system/vibration"

export function fireRealisticConfetti() {
  console.log('fireRealisticConfetti: запуск реалистичного конфетти')
  
  // Вызываем приятную вибрацию для празднования
  vibratePattern('success')
  
  // Дополнительная вибрация через секунду для усиления празднования
  setTimeout(() => {
    vibratePattern('button')
  }, 1000)
  
  const count = 200
  const defaults = {
    origin: { y: 0.7 }
  }

  function fire(particleRatio: number, opts: any) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    })
  }

  // Запускаем несколько волн конфетти для реалистичного эффекта
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  })
  
  fire(0.2, {
    spread: 60,
  })
  
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  })
  
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  })
  
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  })
}
